import React from 'react';
import { NavLink } from 'react-router-dom';
import './style.scss';

const MyBiyesadi = () => {
  const links = [
    { to: '/my-dashboard', label: 'Dashboard', end: true },
    { to: '/my-dashboard/profile', label: 'Profile' },
    { to: '/my-dashboard/photos', label: 'Photo' },
    { to: '/my-dashboard/partner-preference', label: 'Partner Preference' },
    { to: '/my-dashboard/settings', label: 'Settings' },
    { to: '/my-dashboard/contact', label: 'Contact Details' },
    { to: '/my-dashboard/package', label: 'Packages' },
    { to: '/my-dashboard/paymentlog', label: 'Payment Log' },
  ];

  return (
    <div className="custom-navbar">
      <div className="container">
        <div className="row">
          <div className="col-12 d-flex flex-wrap justify-content-start gap-2">
            {links.map((link, index) => (
              <NavLink
                key={index}
                to={link.to}
                end={link.end}
                className={({ isActive }) =>
                  isActive ? 'btn isActive' : 'btn'
                }
              >
                {link.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyBiyesadi;
